import {
  Typography,
  type TypographyProps,
} from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

interface HeadingProps extends Omit<TypographyProps, 'children'> {
  readonly tx: MessageKey;
}

const Heading = ({ tx, ...props }: HeadingProps) => {
  const t = useTranslations();
  return (
    <Typography Element="h2" variant="h2" className="mt-20 mb-8" {...props}>
      {t(tx)}
    </Typography>
  );
};

export default Heading;
